import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { OfferFieldComponent } from './offer-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    OfferFieldComponent,
  ],
  exports: [
    OfferFieldComponent,
  ],
})
export class OffersExportModule {}
